import { DeployStepName } from '@/types/board';

export interface DeployStep {
  name: DeployStepName;
  label: string;
  successMessage: string;
}

export const DEPLOY_STEPS: DeployStep[] = [
  {
    name: 'codebuild_start',
    label: 'Codebuild_start',
    successMessage: '코드 빌드를 시작합니다.',
  },
  {
    name: 'security_scan',
    label: 'Security_scan',
    successMessage: '보안 검사를 통과했습니다.',
  },
  {
    name: 'build',
    label: 'Build',
    successMessage: '코드 빌드에 성공했습니다.',
  },
  {
    name: 'deploy',
    label: 'Deploy',
    successMessage: '배포에 성공했습니다.',
  },
];

// 애니메이션 타이밍 (ms)
export const ANIMATION_TIMING = {
  // 완료 전환 (in_progress → completed)
  CIRCLE_SHRINK_DELAY: 220, // 원 수축 시작 시점
  STEP_COMPLETE: 620, // 체크마크 등장 + 메시지 + 다음 step 시작
  SVG_SPRING: 620, // 체크마크 스프링 애니메이션 시작

  // 확장 전환 (pending → in_progress)
  EXPAND_DURATION: 420, // 확장 애니메이션 완료
  SPINNER_DELAY: 300, // 스피너 등장 지연
} as const;

export const STEP_INDEX_MAP: Record<DeployStepName, number> = {
  codebuild_start: 0,
  security_scan: 1,
  build: 2,
  deploy: 3,
};
